'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var File = (_temp = _class = function (_SvgIcon) {
  _inherits(File, _SvgIcon);

  function File() {
    _classCallCheck(this, File);

    return _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).apply(this, arguments));
  }

  _createClass(File, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', {
            d: 'M15.1900452,11 L41.0199486,11 L50.4945632,22.4054042 C50.8211955,22.7985994 51,23.2936636 51,23.80483 L51,51.8099548 C51,53.0194833 50.0194833,54 48.8099548,54 L15.1900452,54 C13.9805167,54 13,53.0194833 13,51.8099548 L13,13.1900452 C13,11.9805167 13.9805167,11 15.1900452,11 Z',
            fill: '#EBEBEB'
          }),
          _react2['default'].createElement('path', {
            d: 'M17.9340659,16 L44.1247654,16 L45.2666177,18.4995403 C45.3461754,18.6736939 45.4511523,18.8350688 45.5781139,18.9783856 L48,21.7122575 L48,48.0659341 C48,49.1340892 47.1340892,50 46.0659341,50 L17.9340659,50 C16.8659108,50 16,49.1340892 16,48.0659341 L16,17.9340659 C16,16.8659108 16.8659108,16 17.9340659,16 Z',
            fill: '#FFFFFF'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#CFD3D4',
            points: '22.2764882 30.1136087 42.5 30.1136087 42.5 26.75 22.2764882 26.75'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#CFD3D4',
            points: '22.2764882 36.9937174 42.5 36.9937174 42.5 33.6301087 22.2764882 33.6301087'
          }),
          _react2['default'].createElement('polygon', {
            fill: '#CFD3D4',
            points: '22.2764882 43.8738261 36 43.8738261 36 40.5102174 22.2764882 40.5102174'
          }),
          _react2['default'].createElement('path', {
            d: 'M51,23 L43.9778824,23 C42.3400891,23 41,21.4233829 41,19.4970112 L41,11 L51,23 Z',
            fill: '#CCCCCC'
          })
        );
      }

      return render;
    }()
  }]);

  return File;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = File;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/File.js
// module id = 1369
// module chunks = 32